import { XStack } from '@/components/ui';

import { type TeamChatHint } from './use-team-chat-composer';

/** What Send will do with what is in the box, with a one-message override for the owner */
export function TeamChatComposerHint({
  hint,
}: {
  readonly hint: TeamChatHint;
}) {
  return (
    <XStack
      data-testid="team-chat-hint"
      className="mt-1 h-8 shrink-0 items-center gap-2 px-2 text-xs text-foreground-muted"
    >
      <span>{hint.text}</span>
      {hint.action && (
        <button
          type="button"
          className="text-foreground underline-offset-2 hover:underline"
          onClick={hint.action.onClick}
        >
          {hint.action.label}
        </button>
      )}
    </XStack>
  );
}
